export enum NewsStyleType {
  BigPic = 'bigpic',
  Card = 'card',
  Common = 'common',
  Covers = 'covers',
  Girl = 'girl',
  Humor = 'humor',
  Icon = 'icon',
  Note = 'note',
  Social = 'social',
}

export interface INewsConfigBigPic {}
export interface INewsConfigCard {}
export interface INewsConfigCommon {}
export interface INewsConfigCovers {}
export interface INewsConfigGirl {}
export interface INewsConfigHumor {}
export interface INewsConfigIcon {}
export interface INewsConfigNote {}
export interface INewsConfigSocial {}

export interface INewsConfig {
  bigPic?: INewsConfigBigPic;
  card?: INewsConfigCard;
  common?: INewsConfigCommon;
  covers?: INewsConfigCovers;
  girl?: INewsConfigGirl;
  humor?: INewsConfigHumor;
  icon?: INewsConfigIcon;
  note?: INewsConfigNote;
  social?: INewsConfigSocial;
}
